import { Injectable } from '@angular/core';
import {MetricComponentObject} from '../classes/metric-component-object';
import {DimensionComponentObject} from '../classes/dimension-component-object';
import {AdRComparison, AdRPeriod} from '../interfaces/ad-reports';
import {Channel} from '../interfaces/channel';
import {Serializer} from '../interfaces/serializer';

export interface ParamFormatters {
  filters: (value: { [key: string]: Array<string> }) => { [key: string]: Array<string> };
  compare: (value: AdRComparison) => AdRComparison;
  period: (value: AdRPeriod) => AdRPeriod;
  conversion_metric:  (value: MetricComponentObject) => string;
  metrics: (value: Array<MetricComponentObject>) => Array<string>;
  dimensions: (value: Array<DimensionComponentObject>) => Array<string>;
  channel: (value: Serializer<Channel>) => string;
}

@Injectable({
  providedIn: 'root'
})
export class ReportParamsService {
  private readonly _formatters: ParamFormatters = {
    filters: (value: any) => value,
    compare: (value: any) => value,
    period: (value: any) => this.formatPeriod(value),
    conversion_metric: (value: MetricComponentObject) => value.payload?.attributes?.slug,
    metrics: (values: Array<MetricComponentObject>) => values.map((value: MetricComponentObject) => value.payload.attributes.slug),
    dimensions: (values: Array<DimensionComponentObject>) => values.map((value: DimensionComponentObject) => value.payload.attributes.slug),
    channel: (value: any): string => value?.attributes?.slug,
  };

  constructor() { }

  public formatPeriod(period: any): AdRPeriod {
    let periodOutput: any = {};

    if (!period.type) {
      return null;
    }

    if (period.type === 'custom_api') {
      periodOutput = period.dates;
      periodOutput.type = 'custom';
    } else if (period.hasOwnProperty('from') && period.hasOwnProperty('to') && (period.type === 'custom' || !period.hasOwnProperty('type'))) {
      periodOutput.from = period.from;
      periodOutput.to = period.to;
      periodOutput.type = 'custom';
    } else {
      periodOutput.type = period.type;
    }

    return periodOutput;
  }

  public format(key: keyof ParamFormatters, value: any): any | null {
    if (this._formatters.hasOwnProperty(key)) {
      return this._formatters[key](value);
    }

    return null;
  }
}
